import React, { useEffect, useState } from "react";
import { DealCard } from "./DealCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useAppSelector } from "../../../../State/Store";

export const Deal = () => {
  const {homeCategory} = useAppSelector(store=>store)
  const [slidesToShow, setSlidesToShow] = useState(9);
  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,     
    autoplaySpeed: 4000,
    cssEase: "ease-in-out"
  };
  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 640) {
        // sm breakpoint
        setSlidesToShow(1);
      } else if (width >= 640 && width < 768) {
        // md breakpoint
        setSlidesToShow(3);
      } else if (width >= 768 && width <1315) {
        // lg breakpoint
        setSlidesToShow(4);
      // } else if (width >= 1024 && width < 1280) {
      //   // xl and above
      //   setSlidesToShow(5);
      }else if (width >= 1315 && width < 1644){
        setSlidesToShow(6)
      }
      else if (width >= 1644 && width < 1844){
        setSlidesToShow(7)
      }else{
        setSlidesToShow(8)
      }
    };

    updateSlides(); // Set on initial render
    window.addEventListener("resize", updateSlides); // Listen for screen resize

    return () => window.removeEventListener("resize", updateSlides);
  }, []);
  return (
    <div className=" lg:px-15 xl:px-50 pb-[7rem]  ">
      <h1  className="text-lg lg:text-4xl font-bold text-primary py-5  text-center">
        TODAY'S DEALS
      </h1>
 <div className="w-[90%] mx-auto">
   <Slider {...settings}>
  {homeCategory.homePageData?.deals.map((item, index) => (
    <div key={index} className="lg:px-1">         {/* optional gutter */}
      <div className="mx-auto  md:w-full flex items-center justify-center">
        <DealCard item={item} />
      </div>
    </div>
  ))}
</Slider>

 </div>
</div>
  );
};
